<template>
  <v-dialog
    v-model="dialog"
    width="1200"
    scrollable
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        depressed
        class="rounded-lg"
        v-bind="attrs"
        v-on="on"
        >
        Arqueo de caja
      </v-btn>
    </template>

    <v-card>
      <v-snackbar
        v-model="alert.active"
        outlined
        color="success"
        :timeout="-1"
        >
        <div
          class="font-weight-medium d-flex align-center"
          style="gap: 12px"
          >
          <v-icon
            color="success"
            >
            mdi-check-circle
          </v-icon>

          <div>
            {{ alert.message }}
          </div>
        </div>

        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            v-bind="attrs"
            @click="alert.active = false"
            >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <v-card-title>
        Arqueo de caja
      </v-card-title>

      <v-card-text
        class="text--primary"
        >
        <v-tabs
          v-model="tab"
          background-color="transparent"
          >
          <v-tab>
            Hoy
          </v-tab>

          <v-tab>
            Listado
          </v-tab>
        </v-tabs>

        <v-tabs-items 
          v-model="tab"
          >
          <v-tab-item>
            <div
              v-if="cashRegister"
              >
              <div
                class="rounded-lg grey lighten-2 px-3 py-2 my-3 d-flex justify-end align-center"
                style="gap: 12px"
                >
                <div
                  class="body-1 font-weight-medium"
                  >
                  ¿Con qué saldo inicia el día?
                </div>

                <div>
                  <v-text-field
                    label="Saldo inicial"
                    v-model="amount"
                    solo
                    flat
                    dense
                    outlined
                    hide-details
                    @blur="updateCashAmount"
                    class="rounded-lg"
                    style="max-width: 200px"
                    ></v-text-field>
                </div>
              </div>

              <div
                class="px-3"
                >
                <list-header></list-header>

                <template
                  v-for="payment in payments"
                  >
                  <payment-card
                    :key="payment.id"
                    :payment="payment"
                    ></payment-card>
                  <v-divider></v-divider>
                </template>

                <div
                  class="text-right font-weight-medium body-2 pt-3"
                  >
                  Saldo inicial: {{ price(cashRegister.amount) }}
                </div>

                <div
                  class="text-right font-weight-bold body-1 py-3"
                  >
                  <div
                    class="d-flex justify-end"
                    style="gap: 12px"
                    >
                    <span
                      class="font-weight-bold"
                      >
                      Total: 
                    </span>

                    <div
                      class="text-right"
                      style="width: 120px"
                      >
                      <div
                        v-for="payment in Object.entries(total)"
                        v-if="payment[1]"
                        >
                        {{ price(payment[1], payment[0]) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="text-right"
                  >
                  <v-btn
                    :disabled="cashRegister.state != 'pending'"
                    color="primary"
                    depressed
                    @click="closeCash"
                    >
                    {{ cashRegister.state == 'pending' ? 'Cierre de caja' : 'Caja cerrada' }}
                  </v-btn>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <list></list>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { CurrentCashRegister } from '@/graphql/queries/cash_registers'
import { EditCashRegister } from '@/graphql/mutations/cash_registers'

const PaymentCard = () => import('@/components/payments/general/Card')
const ListHeader = () => import('@/components/payments/general/Header')
const List = () => import('@/components/balances/cash_register/List')

export default {
  data: () => ({
    tab: null,
    payments: [],
    cashRegister: null,
    dialog: false,
    amount: 0,
    alert: {
      active: false,
      message: ''
    },
    total: {
      "ARS": 0,
      "USD": 0
    }
  }),

  created () {
    this.fetchCashRegister ()
  },

  methods: {
    fetchCashRegister () {
      this.$apollo.query({
        query: CurrentCashRegister,
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.payments = res.data.currentCashRegister.payments
        this.cashRegister = res.data.currentCashRegister
        this.amount = res.data.currentCashRegister.amount

        this.total = {
          "ARS": 0,
          "USD": 0
        }

        this.payments.forEach( payment => {
          this.total[payment.currency] += payment.lastingAmount
          console.log(this.total)
        })
      })
    },

    price (amount, currency = "ARS") {
      const options = { style: 'currency', currency: currency };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(amount))
    },

    updateCashAmount () {
      this.$apollo.mutate({
        mutation: EditCashRegister,
        variables: {
          input: {
            id: this.cashRegister.id,
            attributes: {
              amount: this.amount
            }
          }
        }
      }).then ( res => {
        this.fetchCashRegister ()
      })
    },

    closeCash () {
      this.$apollo.mutate({
        mutation: EditCashRegister,
        variables: {
          input: {
            id: this.cashRegister.id,
            attributes: {
              state: 'closed'
            }
          }
        }
      }).then ( res => {
        this.fetchCashRegister ()

        this.alert = {
          active: true,
          message: 'Cierre de caja realizado con éxito'
        }
      })
    },
  },

  components: {
    PaymentCard,
    ListHeader,
    List,
  }
}
</script>
